import React from 'react';

const COPY = "Your payment didn't go through. Update your card to keep your account active.";

function agentPaymentPastDue(profile) {
  return Boolean(profile && String(profile.subscription_status || '').toLowerCase() === 'past_due');
}

function AgentPastDueNotice({ profile, onUpdateCard, colors, isDark, busy }) {
  if (!agentPaymentPastDue(profile)) return null;
  const surface = colors && colors.surface ? colors.surface : '#fff';
  const text = colors && colors.text ? colors.text : '#1a1a1a';
  const border = isDark ? '#d1d5db' : '#1a1a1a';
  return (
    <div
      data-testid="agent-past-due"
      role="status"
      style={{
        background: surface,
        color: text,
        border: '1px solid ' + border,
        borderRadius: '12px',
        padding: '1.25rem',
        margin: '0 0 1rem',
      }}
    >
      <p style={{ margin: 0, fontSize: '1rem', lineHeight: 1.5 }}>{COPY}</p>
      <button
        type="button"
        className="agent-past-due-action"
        onClick={onUpdateCard}
        disabled={busy}
        style={{
          width: '100%',
          marginTop: '0.75rem',
          minHeight: '48px',
          borderRadius: '8px',
          border: '1px solid ' + ((colors && colors.border) || '#d5e4e4'),
          background: 'transparent',
          color: text,
          fontSize: '1rem',
          fontWeight: 650,
          cursor: busy ? 'not-allowed' : 'pointer',
          whiteSpace: 'nowrap',
          overflowWrap: 'normal',
          wordBreak: 'keep-all',
        }}
      >
        Update your payment method
      </button>
    </div>
  );
}

export { COPY as AGENT_PAST_DUE_COPY, agentPaymentPastDue, AgentPastDueNotice };
